// app/javascript/controllers/ats_job_description_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "optimizeButton"]

  get value() { return (this.textareaTarget.value || "").trim() }

  onInput() {
    const has = this.value.length > 0
    this.optimizeButtonTarget.disabled = !has
    this.dispatch("job-description-changed", {
      detail: { length: this.value.length },
      prefix: "ats-optimizer"
    })
  }

  requestOptimize() {
    if (!this.value) return
    this.dispatch("optimize-requested", {
      detail: { jdText: this.value },
      prefix: "ats-optimizer"
    })
  }
}
